<template>
  <router-link v-if="to" :to="to" class="Button">
    <slot />
  </router-link>
  <button v-else class="Button" type="button">
    <slot />
  </button>
</template>

<script setup>
defineOptions({ name: 'Button' })

const props = defineProps({
  to: {
    type: [String, Object],
    required: false
  }
})
</script>

<style lang="scss" scoped>
@use '../assets/scss/variables' as *;
@use '../assets/scss/typography' as *;

.Button {
  @extend %button-text-large;
  display: inline-block;
  padding: $spacing-sm $spacing-lg;
  background-color: var(--theme-button-bg);
  color: var(--theme-bg)!important;
  text-decoration: none;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    background-color: var(--theme-button-bg-hover);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }

  &:active {
    background-color: var(--theme-button-bg-active);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.10);
    transform: scale(0.95);
  }
}
</style>
